import React from 'react';

export const Table = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="#72706F" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.8 6.4h14.4V20H4.8z" />
        <path d="M4.8 6.4h14.4v4.945H4.8z" />
      </g>
    </svg>
  );
};

export default Table;
